import dayjs from "dayjs";

export const getOverviewCSVData = (data = []) => {
  return data.map((vehicle) => {
    const row = {
      Vehicle: vehicle.vehicleName || "-",
      "Active Days": vehicle.activeDays ?? 0,
      "Total Distance": vehicle.TotalDistance ?? 0,
    };

    (vehicle.dates || []).forEach((dateObj) => {
      row[dateObj.date] = dateObj.distance ?? 0;
    });

    return row;
  });
};

export const getDetailedLogsCSVData = (data = []) => {
  return data.map((item) => ({
    "Vehicle Name": item.Regno || "-",
    "Device ID": item.FAssetID || "-",
    Date: item.FDate ? dayjs(item.FDate).format("DD/MM/YYYY") : "-",
    "Total Distance": item.FTotalMileage ?? 0,
    "Start Mileage": item.FStartMileage ?? 0,
    "End Mileage": item.FEndMileage ?? 0,
  }));
};